import React from 'react';

export default function ThreeNightButton() {
  return (
    <button className='flybook-book-now-button fb-widget-type-frontend fb-default-category-id-0 fb-account-id-64 fb-entity-config-id-79 fb-domain-go.theflybook.com fb-protocol-https flybook'>
      BOOK NOW
    </button>
  );
}
